// Shared helpers for the casing's original + retread life stages.
//
// Both the detail view and the register consume the same retreadHistory array.
// Keeping stage selection here prevents the two screens from disagreeing about
// which entry is current or which entry belongs to a numbered cap.

const isBlank = (v) => v === null || v === undefined || v === '';

function stageNumber(stage) {
  const n = Number(stage?.stageNo);
  return Number.isInteger(n) && n >= 0 ? n : null;
}

/** Valid history entries, ordered from original (0) to newest stage. */
export function tyreLifeStages(tyre = {}) {
  if (!Array.isArray(tyre.retreadHistory)) return [];
  return tyre.retreadHistory
    .filter((stage) => stage && stageNumber(stage) !== null)
    .slice()
    .sort((a, b) => stageNumber(a) - stageNumber(b));
}

/** One numbered stage, or null when that stage is not recorded. */
export function tyreLifeStage(tyre = {}, stageNo) {
  const wanted = Number(stageNo);
  return tyreLifeStages(tyre).find((stage) => stageNumber(stage) === wanted) || null;
}

/** The latest completed stage. AT_RETREAD does not create or advance a stage. */
export function currentTyreLifeStage(tyre = {}) {
  const stages = tyreLifeStages(tyre);
  return stages.length ? stages[stages.length - 1] : null;
}

/** Null-preserving accessors for register/CSV columns. */
export function stageMetric(tyre, stageNo, key) {
  const value = tyreLifeStage(tyre, stageNo)?.[key];
  return isBlank(value) ? null : value;
}

export function currentStageMetric(tyre, key) {
  const value = currentTyreLifeStage(tyre)?.[key];
  return isBlank(value) ? null : value;
}

